module.exports = __webpack_public_path__ + "img/list_msteams.338e108d.webp";